export function formatMessageTime(createdAt) {
  if (!createdAt) return "";
  const ts = typeof createdAt === "string" ? createdAt : String(createdAt);
  const date =
    ts.includes("Z") || ts.includes("+")
      ? new Date(ts)
      : new Date(ts.replace(" ", "T") + "Z");
  return date.toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" });
}

export function isProbablyGifUrl(value) {
  const text = String(value || "").trim().toLowerCase();
  if (!text.startsWith("http")) return false;
  return (
    text.includes("giphy.com") ||
    text.includes("tenor.com") ||
    text.includes(".gif") ||
    text.includes("/media/")
  );
}

export function getMessagePreview(message) {
  const text = String(message?.message || "").trim();
  if (!text) return "No messages yet";
  return isProbablyGifUrl(text) ? "GIF" : text;
}

export function buildInboxItems({
  friends,
  dmInbox,
  groups,
  onlineFriends,
  unreadCounts,
  unreadGroupCounts,
  selectedFriendId,
  selectedGroupId,
  directMessagesByFriend,
  groupMessages,
  query,
}) {
  const dmMap = new Map();
  (friends || []).forEach((friend) => {
    dmMap.set(Number(friend.user_id), {
      user_id: friend.user_id,
      username: friend.username,
      profile_picture: friend.profile_picture || null,
      inbox_message: "",
      inbox_created_at: null,
      inbox_unread_count: 0,
    });
  });
  (dmInbox || []).forEach((row) => {
    const id = Number(row.user_id);
    const prev = dmMap.get(id);
    dmMap.set(id, {
      user_id: row.user_id,
      username: row.username || prev?.username || "Unknown",
      profile_picture: row.profile_picture || prev?.profile_picture || null,
      inbox_message: row.message || prev?.inbox_message || "",
      inbox_created_at: row.created_at || prev?.inbox_created_at || null,
      inbox_unread_count:
        Number(row.unread_count) || Number(prev?.inbox_unread_count) || 0,
    });
  });

  const dmItems = Array.from(dmMap.values()).map((friend) => {
    const dmKey = Number(friend.user_id);
    const thread = directMessagesByFriend[dmKey] || directMessagesByFriend[friend.user_id] || [];
    const latest = thread[thread.length - 1];
    const latestCreatedAt = latest?.created_at || friend.inbox_created_at;
    const previewSource = latest || { message: friend.inbox_message };
    const unread = unreadCounts[dmKey] ?? unreadCounts[friend.user_id] ?? friend.inbox_unread_count ?? 0;
    const isOnline = onlineFriends.has(dmKey) || onlineFriends.has(friend.user_id);
    return {
      id: `dm-${friend.user_id}`,
      type: "dm",
      keyId: friend.user_id,
      name: friend.username,
      avatar: friend.profile_picture || null,
      preview: getMessagePreview(previewSource),
      timestamp: formatMessageTime(latestCreatedAt),
      sortAt: latestCreatedAt ? new Date(latestCreatedAt).getTime() : 0,
      statusText: isOnline ? "Online" : "Offline",
      unread,
      isActive:
        selectedFriendId != null &&
        Number(selectedFriendId) === Number(friend.user_id) &&
        !selectedGroupId,
    };
  });

  const groupItems = (groups || []).map((group) => {
    const gKey = Number(group.group_id);
    const thread =
      groupMessages[gKey] || groupMessages[group.group_id] || [];
    const latest = thread[thread.length - 1];
    const unread =
      unreadGroupCounts[gKey] ??
      unreadGroupCounts[group.group_id] ??
      0;
    return {
      id: `group-${group.group_id}`,
      type: "group",
      keyId: group.group_id,
      name: group.name,
      avatar: null,
      preview: getMessagePreview(latest),
      timestamp: formatMessageTime(latest?.created_at),
      sortAt: latest?.created_at ? new Date(latest.created_at).getTime() : 0,
      statusText: `${group.member_count || group.members?.length || 0} members`,
      unread,
      isActive:
        selectedGroupId != null && Number(selectedGroupId) === Number(group.group_id),
    };
  });

  const merged = [...dmItems, ...groupItems].sort((a, b) => (b.sortAt || 0) - (a.sortAt || 0));
  const q = String(query || "").trim().toLowerCase();
  if (!q) return merged;
  return merged.filter(
    (item) =>
      item.name.toLowerCase().includes(q) || item.preview.toLowerCase().includes(q)
  );
}
